import { UserManagerSettings } from 'oidc-client-ts'

import { getCurrentUrl } from 'Shared/utils/url/helpers'

import { getEnv } from 'Core/env'
import Auth from 'Core/utils/auth'

const env = getEnv()
const locationHref = getCurrentUrl()

const authSettings: UserManagerSettings = {
	authority: env.REACT_APP_OIDC_AUTHORITY,
	client_id: 'js-customer',
	post_logout_redirect_uri: locationHref,
	redirect_uri: locationHref,
	automaticSilentRenew: true,
	query_status_response_type: 'code',
	scope: 'openid profile is2_customer'
}

export const AuthInstance = Auth.getInstance(authSettings)
